var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZelle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 0H6a6 6 0 0 0-6 6v41a6 6 0 0 0 6 6h41a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6Z",
    fill: "#6D1DD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23.381 14.57-7.87-.064v4.634h13.043L15 34.561v3.922h8.381V43h5.03v-4.517h8.548c.072-.18.098-.668-.357-1.114a10.898 10.898 0 0 1-1.905-2.5c-.252-.435-.443-.957-.515-1-1.683-.068-11.369-.05-11.363-.105l13.566-15.516V14.57H28.41V10h-5.029v4.57Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZelle);
export default __webpack_public_path__ + "static/media/zelle.271687c5c0ab691bbba74a61604d5379.svg";
export { ForwardRef as ReactComponent };